import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const phone: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11-2.312q0 .206-.078.546a4 4 0 0 1-.156.532q-.176.393-.953.828Q9.074.002 8.359 0q-.223.002-.421-.031-.207-.03-.454-.094-.235-.074-.359-.11-.128-.044-.437-.156a4 4 0 0 1-.375-.156 7 7 0 0 1-1.375-.64q-.985-.622-2.063-1.688Q1.81-3.953 1.188-4.937a7 7 0 0 1-.641-1.375 4 4 0 0 1-.156-.375q-.11-.31-.157-.438a10 10 0 0 0-.109-.36 4 4 0 0 1-.094-.452A2.4 2.4 0 0 1 0-8.36q-.002-.715.406-1.453.436-.778.828-.954.186-.074.532-.156.34-.076.547-.078.106.002.171.016.139.047.407.593.093.157.234.438.152.269.281.484.123.224.235.422.03.035.14.203c.07.106.125.196.157.266q.06.112.062.219 0 .157-.219.39a4 4 0 0 1-.484.438q-.269.188-.484.406-.222.22-.22.36-.001.081.032.187c.031.062.05.117.063.156l.109.188a1 1 0 0 1 .094.14A8 8 0 0 0 4.25-4.25a8 8 0 0 0 1.844 1.36q.012 0 .14.093.141.081.188.11c.039.011.094.03.156.062q.105.033.188.031c.093 0 .21-.07.359-.218q.218-.216.406-.485c.133-.176.282-.336.438-.484Q8.202-4 8.359-4q.106.001.22.063c.07.03.16.085.265.156q.169.11.203.14l.422.235q.215.13.484.281.28.141.438.234c.363.18.562.313.593.407a1 1 0 0 1 .016.172m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "11",
  }
};
